import { render, staticRenderFns } from "./BuyerDocumentsList.vue?vue&type=template&id=2c643318&scoped=true&"
import script from "./BuyerDocumentsList.vue?vue&type=script&lang=js&"
export * from "./BuyerDocumentsList.vue?vue&type=script&lang=js&"
import style0 from "./BuyerDocumentsList.vue?vue&type=style&index=0&id=2c643318&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c643318",
  null
  
)

export default component.exports